var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{staticClass:"overflow-x-hidden",attrs:{"title":"Calculate your ROI: ID digital solutions ROI calculator","transparent":true}},[_c('section1'),_vm._v(" "),_c('calculatorSection',{attrs:{"errors":_vm.errors,"isV1":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }